import { Box, Typography } from '@mui/material';
import { MultiSelect } from 'react-multi-select-component';

const MultiDropdown = ({
  filterKey,
  selectedValue,
  label,
  options,
  onChange,
}: {
  filterKey: string;
  label?: string;
  options: any;
  selectedValue: any;
  onChange: (key: string, value: any) => void;
}) => {
  const defaultValue = () => {
    return options
      ? options.filter((option: any) => selectedValue?.includes(option.value))
      : [];
  };

  return (
    <Box
      sx={{
        '& .rmsc .dropdown-container': {
          boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
          background: '#FFFFFF !important',
          borderRadius: '8px',
          border: 'transparent !important',
        },
        '& .dropdown-heading': {
          height: '42px !important',
        },
        '& .dropdown-heading-value': {
          maxWidth: '100px !important',
        },
      }}
    >
      <Typography align='center'>{label}</Typography>
      <MultiSelect
        options={options}
        value={defaultValue()}
        onChange={(e: any) => {
          const selected = e.map((item: any) => item.value);
          onChange(filterKey, selected);
        }}
        hasSelectAll={false}
        disableSearch={true}
        labelledBy='Select'
      />
    </Box>
  );
};
export default MultiDropdown;
